import logo from './logo.svg';
import './App.css';
import MainLayout from './layouts/MainLayout';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import AddSaham from './pages/AddSaham';
import CariSaham from './pages/CariSaham';
import TambahTransaksiSaham from './pages/TambahTransaksiSaham';
import TambahSetorSaham from './pages/TambahSetorSaham';
import DaftarTransaksi from './pages/DaftarTransaksi';


function App() {
  return (
    <Routes>
      <Route element={<MainLayout/>}>
        <Route path="/" element={<Home/>} />
        <Route path="/add-saham" element={<AddSaham/>} />
        <Route path="/cari-saham/" element={<CariSaham/>} />
        <Route path="/cari-saham/:sahamId/" element={<CariSaham/>} />
        <Route path="/cari-saham/:sahamId/tambah-transaksi" element={<TambahTransaksiSaham/>} />
        <Route path="/setor" element={<TambahSetorSaham />} />am/>} />
        <Route path="/daftar-transaksi" element={<DaftarTransaksi />} />
      </Route>
    </Routes>
  );
}

export default App;
